/**
 * The order of values here will also be the order of options when used in <EnumSelector>
 */
export enum OverdueImpactEnum {
    REVENUE_LOSS = 1,
    COMPLIANCE = 2,
    OTHER = 1000,
}

export const OverdueImpactEnumDict = {
    [OverdueImpactEnum.REVENUE_LOSS]: 'Revenue Loss',
    [OverdueImpactEnum.COMPLIANCE]: 'Compliance',
    [OverdueImpactEnum.OTHER]: 'Other',
};
